import { useState } from 'react';

import type { DrawerState } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.types';

import type { CriticalPopulationResponse } from 'api/generated/schemas';

export interface RetainedDrawer {
  drawer: Exclude<DrawerState, { mode: 'closed' }>;
  row: CriticalPopulationResponse | undefined;
  session: number;
}

interface UseRetainedDrawerResult {
  retained: RetainedDrawer | null;
  release: () => void;
}

export const useRetainedDrawer = (
  drawer: DrawerState,
  row: CriticalPopulationResponse | undefined
): UseRetainedDrawerResult => {
  const [retained, setRetained] = useState<RetainedDrawer | null>(null);
  const [sessionCount, setSessionCount] = useState(0);

  if (
    drawer.mode !== 'closed' &&
    (retained?.drawer !== drawer || retained.row !== row)
  ) {
    const isNewSession = retained?.drawer !== drawer;
    const session = isNewSession ? sessionCount + 1 : retained.session;

    setSessionCount(session);
    setRetained({ drawer, row, session });
  }

  return {
    retained,
    release: () => setRetained(null),
  };
};
